module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "stroke-current text-grey-light",
    attrs: {
      "height": "24",
      "width": "24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.5 20.5c0 1.7-1.3 3-3 3s-3-1.3-3-3M19.5 13.5v-5c0-3.9-3.1-7-7-7s-7 3.1-7 7v5c0 4-2 7-2 7h18s-2-3-2-7z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9f12290","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/sidemenu/svgs/NotificationSVG.vue
// module id = 588
// module chunks = 66